import { InventoryGroupDetailContent } from "../../content/inventoryGroup/inventoryGroupDetail";
import { Layout } from "../../layout/page";

export function InventoryGroupDetail() {
  return (
    <Layout>
      <InventoryGroupDetailContent />
    </Layout>
  );
}
